import SharedProcessingTimeSection from "@/components/feature/SharedProcessingTimeSection";
import type { ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Appointment required — no walk-ins allowed",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Predictable turnaround",
      "Ideal for upcoming trips",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service",
      "Good for planned travel",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "Workload & wait times shift with shutdowns and budget fights",
      "In-person clerk appointment required",
      "No document review — errors cause rejection",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Can't upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
];

export default function ThibodauxProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Thibodaux"
      headingExtra="LA"
      introText="Thibodaux travelers — Nicholls State students, offshore oil workers, and Bayou Lafourche business owners — have several passport options. Here is how they compare, and why most Lafourche Parish residents choose a registered State Department courier rather than driving 60 miles to New Orleans for a passport agency appointment."
      options={options}
      emergencyDescription="New Orleans ~60 mi via US-90 and I-310 — a drive measured in hours, not miles, through bayou country. Louisiana's single agency serves 4.6M. Nicholls State sends students abroad every semester and offshore oil workers rotate to rigs in the Gulf, West Africa, and Brazil on two-week cycles. During hurricane season, US-90 and I-310 are mandatory evacuation routes — when Lafourche Parish evacuates, the highways run north only and the New Orleans agency becomes unreachable. Hurricane Ida (2021) devastated this exact corridor — US-90 was impassable for days, the I-310 approach flooded, and the New Orleans agency closed. An offshore roughneck with a helicopter flight to a Gulf platform cannot wait for the bayous to drain."
      disclaimerText="*Processing speed depends on eligibility and documentation. Not all applicants qualify for Regional Agency Processing."
    />
  );
}